exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".StarRating-module__play__rating__3hSRp {\r\n    text-align: center;\r\n    margin: auto;\r\n    position: relative;\r\n    width: 80%;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    overflow: hidden;\r\n}\r\n\r\n.StarRating-module__play__rating_img__3ZwSD {\r\n    width: 64px;\r\n    height: 64px;\r\n}\r\n\r\n@media (max-width: 799px) {\r\n  \r\n    .StarRating-module__play__rating__3hSRp {\r\n      width: 320px;\r\n    }\r\n  \r\n    .StarRating-module__play__rating_img__3ZwSD {\r\n      width: 32px;\r\n      height: 32px;\r\n    }\r\n  \r\n}", ""]);

// exports
exports.locals = {
	"play__rating": "StarRating-module__play__rating__3hSRp",
	"play__rating_img": "StarRating-module__play__rating_img__3ZwSD"
};